import * as React from 'react';
import { IconButton } from '@cian/frontend-reviews-components';
import { IconLike16, IconDislike16 } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-restricted-paths
import { setReviewReaction } from '../../../browser/services/reviews/setReviewReaction';
import { requestAuthentication } from '../../actions/authentication';
import { ReviewsReactions } from '../../components/ReviewsReactions';
import { ILikeSchema, EStatus } from '../../repositories/newbuilding-card/entities/reviews/LikeSchema';
import { getIsAuthenticated } from '../../selectors/user';

export interface IReviewsReactionsContainerProps {
  reviewId: string;
  reactions: ILikeSchema;
}

export const ReviewsReactionsContainer: React.FC<IReviewsReactionsContainerProps> = ({ reviewId, reactions }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const setAnswerLike = React.useCallback(() => setReviewReaction({ reviewId, type: EStatus.Liked }), []);
  const setAnswerDislike = React.useCallback(() => setReviewReaction({ reviewId, type: EStatus.Disliked }), []);

  const onLikeClick = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setAnswerLike() as any);
    } else {
      dispatch(requestAuthentication({ onSuccess: setAnswerLike }) as any);
    }
  }, [dispatch, isAuthenticated, setAnswerLike, requestAuthentication]);

  const onDislikedClick = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setAnswerDislike() as any);
    } else {
      dispatch(requestAuthentication({ onSuccess: setAnswerDislike }) as any);
    }
  }, [dispatch, isAuthenticated, setAnswerDislike, requestAuthentication]);

  return (
    <ReviewsReactions
      like={
        <IconButton
          Icon={IconLike16}
          active={reactions.status === EStatus.Liked}
          onClick={onLikeClick}
          label={reactions.likesCount}
        />
      }
      dislike={
        <IconButton
          Icon={IconDislike16}
          active={reactions.status === EStatus.Disliked}
          onClick={onDislikedClick}
          label={reactions.dislikesCount}
        />
      }
    />
  );
};
